module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-week-header",
    style: (_vm.style)
  }, [_c('div', {
    staticClass: "ds-hour-list"
  }), _vm._v(" "), _vm._l((_vm.days), function(day) {
    return [_c('ds-week-day-header', _vm._g(_vm._b({
      attrs: {
        "day": day,
        "calendar": _vm.calendar,
        "placeholder": _vm.placeholder,
        "placeholder-for-create": _vm.placeholderForCreate
      }
    }, 'ds-week-day-header', {
      $scopedSlots: _vm.$scopedSlots
    }, false), _vm.$listeners))]
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dc94a82e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WeekHeader.vue
// module id = 186
// module chunks = 0